import { Component, OnInit, ViewChild, AfterContentInit, EventEmitter, OnDestroy } from '@angular/core';
import { BoardService } from 'src/app/services/board.service';
import { Board, List, Card, Tag } from 'src/app/models/board.model';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import Swal from 'sweetalert2';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { Options } from 'select2';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

declare var bootstrap: any;

declare var botmanWidget: any;

@Component({
  selector: 'app-home2',
  templateUrl: './home2.component.html',
  styleUrls: ['./home2.component.css']
})
export class Home2Component implements OnInit, AfterContentInit, OnDestroy {
  @BlockUI('procuracoes') blockUI!: NgBlockUI;

  @ViewChild('selectEscritorio')
  selectEscritorio!: any;

  isOK = false;

  options1!: Options;
  isBlocked: boolean = false;
  isBlockedEvent: EventEmitter<boolean> = new EventEmitter()
  loading: boolean = false;
  escritorio: number = -1;
  filtro: string = '';
  filtro_inicio: string = '';
  filtro_fim: string = '';

  board!: Board;

  editingListId!: number;

  modalView: any;
  optionsTag!: Options;

  loading_atividade: boolean = false;
  atividade_data: Array<atividade> = [];

  loading_tags: boolean = false;
  loading_identificacao: boolean = false;
  identificacao_data: identificacao = {
    razao: '',
    cnpj: '',
    validade: '',
    tags: [],
    tags_data: [],
    procuracoes: [],
    alerta: 0
  };

  comentario: string = "";
  loading_comentario: boolean = false;

  scanCheck!: NodeJS.Timer;

  selected!: selected;

  public grupoData = [
    {
      id: 'dyn1',
      text: 'Dynamic 1',
    }
  ];

  public grupoData2 = [
    {
      id: 'dyn1',
      text: 'Dynamic 1',
      cor: ''
    }
  ];

  idList: Array<string> = [];
  currentCard!: Card;

  constructor(private boardService: BoardService, public userService: UserService, private router: Router, public sanitizer: DomSanitizer) { }

  ngOnInit() {
    if (this.userService.checarPermissao('1')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    this.options1 = {
      allowClear: true,
      placeholder: 'Selecione um Escritório',
      ajax: {
        type: 'POST',
        url: environment.apiEndpoint + 'select-escritorio',
        dataType: 'json',
        contentType: "application/json",
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        delay: 250,
        data: (params) => {
          return JSON.stringify({
            q: params.term,
          });
        },
        error: (xhr: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        },
        processResults: (data) => {
          return {
            results: data,
          };
        },
        cache: true,
      },
      language: "pt-BR"
    };

    this.optionsTag = {
      allowClear: true,
      placeholder: 'Tags',
      multiple: true,
      ajax: {
        type: 'POST',
        url: environment.apiEndpoint + 'select-tags',
        dataType: 'json',
        contentType: "application/json",
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        delay: 250,
        data: (params) => {
          return JSON.stringify({
            q: params.term,
          });
        },
        error: (xhr: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        },
        processResults: (data) => {
          return {
            results: data,
          };
        },
        cache: true,
      },
      language: "pt-BR",
      dropdownParent: $('#view'),
      templateResult: (state: any): JQuery | string => {
        if (!state.id || Number(state.id) == 0) {
          return state.text;
        }
        return jQuery('<span class="badge" style="background-color: ' + (state as any).cor + '">' + state.text + '</span>');
      },
      templateSelection: (state: any): JQuery | string => {
        if (!state.id || Number(state.id) == 0) {
          return state.text;
        }
        return jQuery('<span class="badge" style="background-color: ' + (state as any).cor + '">' + state.text + '</span>');
      }
    };

    this.modalView = new bootstrap.Modal(
      document.getElementById('view'),
      {
        backdrop: 'static',
      }
    );

    this.isBlockedEvent.subscribe(itemData => {
      this.isBlocked = itemData;
      if (this.isBlocked) {
        this.blockUI.start('Escaneando Procurações...');
        this.scanCheck = setInterval(() => {
          this.ScanCheck()
        }, 5000);
      } else {
        clearInterval(this.scanCheck);
        this.blockUI.stop();
      }
    })
  }

  ScanCheck() {
    this.userService.checarScan(this.escritorio).subscribe(
      (res: any) => {
        if (res.scan === 0) {
          this.isBlockedEvent.emit(false);
          const n_id = this.escritorio;
          this.escritorio = -1;
          this.fetchDashboard(n_id.toString())
        }
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
      }
    )
  }

  Filtrar(card: Card) {
    if (card.title.toLocaleLowerCase().includes(this.filtro.toLocaleLowerCase())) {
      let d1 = new Date(card.vencimento.split("/")[2] + '-' + card.vencimento.split("/")[1] + '-' + card.vencimento.split("/")[0]);
      if (this.filtro_inicio['year'] !== undefined && this.filtro_fim['year'] !== undefined) {
        let d2 = new Date(this.filtro_inicio['year'] + '-' + this.filtro_inicio['month'] + '-' + this.filtro_inicio['day']);
        let d3 = new Date(this.filtro_fim['year'] + '-' + this.filtro_fim['month'] + '-' + this.filtro_fim['day']);
        if (d1 > d2 && d1 < d3) {
          return true;
        }
        return false;
      }
      if (this.filtro_inicio['year'] !== undefined) {
        let d2 = new Date(this.filtro_inicio['year'] + '-' + this.filtro_inicio['month'] + '-' + this.filtro_inicio['day']);
        if (d1 > d2) {
          return true;
        }
        return false;
      }
      if (this.filtro_fim['year'] !== undefined) {
        let d2 = new Date(this.filtro_fim['year'] + '-' + this.filtro_fim['month'] + '-' + this.filtro_fim['day']);
        if (d1 < d2) {
          return true;
        }
        return false;
      }
      return true;
    }
    return false;
  }

  ngOnDestroy(): void {
    this.isBlockedEvent.unsubscribe();
    if (this.scanCheck) {
      clearInterval(this.scanCheck);
    }
  }

  ngAfterContentInit(): void {
    let tmp = this.userService.getEscritorio();
    if (tmp![0] === 0) {
      return;
    }
    this.grupoData = [];
    this.grupoData.push({
      id: tmp![0],
      text: tmp![1],
    })
    this.fetchDashboard(tmp![0].toString())
  }

  fetchDashboard(id: string) {
    const n_id = Number(id);
    if (this.escritorio !== n_id) {
      let tmp = this.userService.getEscritorio();
      if (tmp![0] === 0) {
        this.userService.setEscritorio(n_id, this.selectEscritorio.element.find(":selected").text())
      }

      this.loading = true;
      this.userService.fetchDashboard(n_id).subscribe(
        (res: any) => {
          this.escritorio = n_id;
          res['dashboard'].map((lista: any) => {
            lista.cards.sort((a: any, b: any) => a.ordem - b.ordem)
            return lista
          });
          res['dashboard'].sort((a: any, b: any) => a.ordem - b.ordem)
          this.board = res['dashboard'];
          this.boardService.setBoard(this.board);
          this.idList = this.board.map((parent) => parent.id.toString());
          this.isBlockedEvent.emit(Boolean(res['scan']));
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.loading = false
        },
        () => this.loading = false
      )
    }
  }

  addListAction(): void {
    Swal.fire({
      title: 'Informe o nome da Lista',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Cadastrar',
      cancelButtonText: 'Cancelar',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel'
      },
      showLoaderOnConfirm: true,
      preConfirm: (nome) => {
        return new Promise(() => {
          (this.userService.cadastrarLista(this.escritorio, nome).subscribe(
            (res: any) => {
              this.boardService.addList(res.id, nome)
              this.idList.push(res.id.toString())
              Swal.fire({
                title: 'Sucesso',
                text: 'Lista adicionada',
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal',
                },
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
            }
          ))
        });
      },
    })
  }

  editTitleList(list: List): void {
    this.editingListId = list.id;
    list.renaming = true;
  }

  getTitleListOnKeyUp(titleListInput: string, list: List): void {
    Swal.fire({
      title: 'Renomear Lista?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Renomear',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel',
      },
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise(() => {
          (this.userService.renomearLista(list.id, titleListInput).subscribe(
            (res: any) => {
              list.name = titleListInput;
              this.editingListId = 0;
              list.renaming = false;
              Swal.fire({
                title: 'Sucesso',
                text: 'Lista renomeada',
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal',
                },
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
            }
          ))
        });
      }
    });
  }

  deleteListAction(list: List) {
    event!.stopPropagation();
    if (list.cards.length === 0) {
      Swal.fire({
        title: 'Excluir lista [' + list.name + ']?',
        icon: 'warning',
        text: 'Este processo é irreversível',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        heightAuto: false,
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          confirmButton: 'btn-swal',
          cancelButton: 'btn-swal-cancel',
        },
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return new Promise(() => {
            (this.userService.excluirLista(list.id).subscribe(
              (res: any) => {
                this.boardService.deleteList(list.id);
                this.idList.splice(this.idList.indexOf(list.id.toString()), 1);
                Swal.fire({
                  title: 'Sucesso',
                  text: 'Lista excluída',
                  icon: 'success',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal',
                  },
                });
              },
              (err: any) => {
                switch (err.status) {
                  case 400:
                    Swal.fire({
                      title: 'Erro',
                      text: String(err.error.message),
                      icon: 'error',
                      heightAuto: false,
                      allowOutsideClick: false,
                      focusConfirm: false,
                      customClass: {
                        confirmButton: 'btn-swal'
                      },
                    });
                    break;
                  case 401:
                    localStorage.removeItem('botway');
                    this.router.navigate(['/login']);
                    break;
                  case 422:
                    let txt = '';
                    Object.values(err.error.errors).forEach((value: any, index) => {
                      for (let i = 0; i < Array(value).length; i++) {
                        txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                      }
                    });
                    Swal.fire({
                      title: 'Erro',
                      html: txt,
                      icon: 'error',
                      heightAuto: false,
                      allowOutsideClick: false,
                      focusConfirm: false,
                      customClass: {
                        confirmButton: 'btn-swal'
                      },
                    });
                    break;
                }
              }
            ))
          });
        }
      });
    }
  }

  drop(event: CdkDragDrop<Card[]>, listIndex: number) {
    if (event.previousContainer === event.container) {
      if (event.previousContainer.data[event.previousIndex].id !== event.previousContainer.data[event.currentIndex].id) {
        let data = {
          'empresa': event.previousContainer.data[event.previousIndex].id,
          'posicao': event.currentIndex,
          'empresa2': event.previousContainer.data[event.currentIndex].id,
          "posicao2": event.previousIndex,
        }

        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

        this.userService.moverItem(data).subscribe(
          (res: any) => {
          },
          (err: any) => {
            switch (err.status) {
              case 400:
                Swal.fire({
                  title: 'Erro',
                  text: String(err.error.message),
                  icon: 'error',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                });
                break;
              case 401:
                localStorage.removeItem('botway');
                this.router.navigate(['/login']);
                break;
              case 422:
                let txt = '';
                Object.values(err.error.errors).forEach((value: any, index) => {
                  for (let i = 0; i < Array(value).length; i++) {
                    txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                  }
                });
                Swal.fire({
                  title: 'Erro',
                  html: txt,
                  icon: 'error',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                });
                break;
            }
          }
        )
      }
    } else {
      let data = {}
      if (event.currentIndex === 0) {
        data = {
          'empresa': this.currentCard.id,
          'lista': listIndex,
          'posicao': event.previousContainer.data.indexOf(this.currentCard),
          'anterior_empresa': event.previousContainer.data.indexOf(this.currentCard) < event.container.data.length ? event.container.data[event.previousContainer.data.indexOf(this.currentCard)].id : -1,
          "anterior_posicao": event.previousContainer.data.indexOf(this.currentCard) < event.container.data.length ? (event.previousContainer.data.indexOf(this.currentCard) + 1) : -1,
        }
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousContainer.data.indexOf(this.currentCard), event.container.data.length);
      } else {
        data = {
          'empresa': event.previousContainer.data[event.previousIndex].id,
          'lista': listIndex,
          'posicao': event.currentIndex,
          'anterior_empresa': event.currentIndex < event.container.data.length ? event.container.data[event.currentIndex].id : -1,
          "anterior_posicao": event.currentIndex < event.container.data.length ? (event.currentIndex + 1) : -1,
        }
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      }

      this.userService.transferirItem(data).subscribe(
        (res: any) => {
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
        }
      )
    }
  }

  openModal(list: List, card: Card) {
    this.comentario = '';
    this.loading_atividade = true;
    this.loading_identificacao = true;
    this.modalView.show();
    this.userService.fetchAtividade(card.id).subscribe(
      (res: any) => {
        this.selected = {
          list,
          card
        };
        this.atividade_data = res;
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        setTimeout(() => {
          this.modalView.hide();
          this.loading_atividade = false
        }, 400);
      },
      () => this.loading_atividade = false
    )

    this.userService.fetchIdentificacao(card.id).subscribe(
      (res: any) => {
        this.identificacao_data.alerta = res.alerta;
        this.identificacao_data.cnpj = res.cnpj;
        this.identificacao_data.procuracoes = JSON.parse(res.procuracoes);
        this.identificacao_data.razao = res.razao;
        this.identificacao_data.tags = JSON.parse(res.tags);
        this.identificacao_data.tags_data = res.tags_data;
        this.identificacao_data.validade = res.validade;
        this.grupoData2 = [];
        if (res.tags !== '[]' && res.tags.length > 0) {
          for (var i = 0; i < res.tags_data.length; i++) {
            this.grupoData2.push(
              {
                id: res.tags_data[i]['id'],
                text: res.tags_data[i]['nome'],
                cor: res.tags_data[i]['cor']
              }
            )
          }
        }
        if (this.identificacao_data.alerta === 1) {
          this.identificacao_data.alerta = 0;
          this.boardService.updateAlert(list, card)
        }
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        setTimeout(() => {
          this.modalView.hide();
          this.loading_identificacao = false
        }, 400);
      },
      () => this.loading_identificacao = false
    )
  }

  inserirComentario() {
    if (this.comentario.length === 0) {
      return;
    }
    this.loading_comentario = true;
    this.userService.inserirComentario(this.selected.card.id, this.comentario).subscribe(
      (res: any) => {
        this.comentario = '';
        this.atividade_data = res;
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.loading_comentario = false
      },
      () => this.loading_comentario = false
    )
  }

  atualizarTags() {
    this.loading_tags = true;
    this.userService.atualizarTags(this.selected.card.id, this.identificacao_data.tags).subscribe(
      (res: any) => {
        this.atividade_data = res.comentarios;
        this.boardService.updateTags(this.selected.list, this.selected.card, res.tags);
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.loading_tags = false
      },
      () => this.loading_tags = false
    )
  }

  getTagColor(tag: Tag) {
    return tag.cor;
  }

  getCardStyle(card: Card) {
    if (card.tags !== null) {
      if (card.tags.length > 0) {
        return '3px solid ' + card.tags[0].cor;
      }
    }
    return "";
  }

  escanearProcuracoes() {
    Swal.fire({
      title: 'Escanear Procurações?',
      text: 'Durante o Processo de busca, o quadro ficará inativo.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Prosseguir',
      cancelButtonText: 'Cancelar',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel'
      },
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise(() => {
          (this.userService.escanearProcuracoes(this.escritorio).subscribe(
            (res: any) => {
              Swal.fire({
                title: 'Sucesso',
                text: res.message,
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal',
                },
              }).then((result) => {
                this.isBlockedEvent.emit(true);
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
            }
          ))
        });
      }
    });
  }

  dropItem(event: any) {
    if (event.previousContainer.data[event.previousIndex].id !== event.previousContainer.data[event.currentIndex].id) {
      if (event.currentIndex === 0) {
        return;
      }
      let data = {
        'lista': event.previousContainer.data[event.previousIndex].id,
        'posicao': event.currentIndex,
        'lista2': event.previousContainer.data[event.currentIndex].id,
        "posicao2": event.previousIndex,
      }

      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      moveItemInArray(this.idList, event.previousIndex, event.currentIndex);

      this.userService.moverLista(data).subscribe(
        (res: any) => {
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
        }
      )
    }
  }
}

export interface atividade {
  momento: string;
  ator: string;
  comentario: string;
}

export interface identificacao {
  razao: string;
  cnpj: string;
  validade: string;
  tags: Array<string>;
  tags_data: Array<tags_data>;
  procuracoes: Array<procuracao>;
  alerta: number;
}

export interface tags_data {
  id: number;
  nome: string;
  cor: string;
}

export interface procuracao {
  status: number;
  procuracao: string;
}

export interface selected {
  list: List;
  card: Card;
}
